// Dependencies
import React, { useEffect } from 'react';
import logo from '../assets/logo/insacom_blanco.svg';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const Footer = () => {
    const location = useLocation();

    useEffect(() => {
        window._paq.push(['trackPageView']);
    }, [location]);

    return (
        <footer>
            <div className="g-bg-gray-dark-v1">
                <div className="container g-pt-30">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 g-mb-30 d-flex d-flex">
                            <div className="g-mx-15">
                                <a className="g-text-underline--none--hover" href="/">
                                    <img className="g-height-45" src={logo} alt="Logo" />
                                </a>
                            </div>
                            <p className="g-line-height-1 align-self-end g-color-gray-dark-v5 g-font-size-13 mb-0">© 2020 Todos los Derechos Reservados.</p>
                        </div>
                        <div className="col-md-6 col-sm-12 g-mb-30 d-flex justify-content-around flex-wrap">
                            <div className="g-mx-15">
                            </div>
                            <div className="g-mx-15">
                                <h4 className="g-color-gray-dark-v5 g-font-size-11 text-left text-uppercase">Contacto Comercial</h4>
                                <a href="mailto:info@insacom.cl">info@insacom.cl</a>
                            </div>
                            <div className="g-mx-15">
                                <h4 className="g-color-gray-dark-v5 g-font-size-11 text-left text-uppercase">Contacto Soporte</h4>
                                <a href="mailto:soporte@insacom.cl">soporte@insacom.cl</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );

}

export default Footer;


// WEBPACK FOOTER //
// ./src/layout/Footer.js